import { Clock3, GitCommitHorizontal, GitFork } from 'lucide-react'
import { formatRelativeSyncTime } from '../../lib/document-kind'
import type { buildActiveSourceOverview } from '../../lib/knowledge-library-state'

type SourceOverview = ReturnType<typeof buildActiveSourceOverview>

export function KnowledgeSourceOverview({ overview }: { overview: SourceOverview }) {
  return (
    <section className="aw-knowledge-source-overview" aria-label="Active source overview">
      <div>
        <span className="aw-label">{overview.kindLabel}</span>
        <strong>{overview.label}</strong>
      </div>
      <span>
        <GitFork className="h-3.5 w-3.5" aria-hidden />
        {overview.count} loaded {overview.count === 1 ? 'document' : 'documents'}
      </span>
      <span>
        <GitCommitHorizontal className="h-3.5 w-3.5" aria-hidden />
        {overview.revisionLabel}
      </span>
      <span>
        <Clock3 className="h-3.5 w-3.5" aria-hidden />
        {overview.latestSyncedAt
          ? `Latest loaded sync ${formatRelativeSyncTime(overview.latestSyncedAt)}`
          : 'No loaded sync time'}
      </span>
    </section>
  )
}
